import { Routes } from '@angular/router';
import { customerIsAdminOrKeyUserGuard, mandantSelectedGuard } from '@zvoove-market/shared';

export const generalRoutes: Routes = [
  {
    path: 'healthz',
    loadComponent: () => import('./healthz/healthz.page').then((c) => c.HealthzPage),
  },
  {
    path: 'temporary-support-access',
    canActivate: [mandantSelectedGuard(), customerIsAdminOrKeyUserGuard()],
    data: {
      breadcrumb: () => $localize`:@@support.temporaryAccess:Temporäre Support-Zugänge`,
    },
    loadComponent: () =>
      import('./temporary-support-access/temporary-support-access-list.page').then((c) => c.TemporarySupportAccessListPage),
  },
  {
    path: 'file-not-found',
    data: {
      breadcrumb: () => $localize`:@@general.fileNotFound:Datei nicht gefunden`,
    },
    loadComponent: () => import('./file-not-found/file-not-found.page').then((c) => c.FileNotFoundPage),
  },
  {
    path: 'mandant-select',
    data: {
      breadcrumb: () => $localize`:@@general.mandantSelection:Mandantenwahl`,
    },
    loadComponent: () => import('./mandant-select/mandant-select.page').then((c) => c.MandantSelectPage),
  },
  {
    path: 'unsubscribe',
    data: {
      breadcrumb: () => $localize`:@@subscribe.unsubscribe:Abmelden`,
    },
    loadComponent: () => import('./unsubscribe/unsubscribe.page').then((c) => c.UnsubscribePage),
  },
  {
    path: 'forbidden',
    data: {
      breadcrumb: () => $localize`:@@general.missingPermissions:Fehlende Berechtigungen`,
    },
    loadComponent: () => import('./forbidden/forbidden.page').then((c) => c.ForbiddenPage),
  },
  {
    path: '**',
    data: {
      breadcrumb: () => $localize`:@@general.pagenNotFound:Seite nicht gefunden`,
    },
    loadComponent: () => import('./page-not-found/page-not-found.page').then((c) => c.PageNotFoundPage),
  },
];
